// sessionStorage, not router location.state: the SSO/OAuth flows redirect the
// whole browser to the IdP and back, which wipes in-memory router state.

const STORAGE_KEY = 'postLoginRedirect';

// Only same-origin app paths, to prevent an open redirect.
const isSafeInternalPath = path =>
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');

export const setPostLoginRedirect = path => {
  if (!isSafeInternalPath(path)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    // sessionStorage may be unavailable (private mode)
  }
};

// Not persisted: tells a live logout apart from a cold load that hydrated
// stale logout state from localStorage.
let authenticatedThisLoad = false;

export const markAuthenticatedThisLoad = () => {
  authenticatedThisLoad = true;
};

export const wasAuthenticatedThisLoad = () => authenticatedThisLoad;

// Read-and-clear is atomic so concurrent consumers can't double-navigate.
export const consumePostLoginRedirect = () => {
  try {
    const path = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return isSafeInternalPath(path) ? path : null;
  } catch {
    return null;
  }
};
